import { Uuid } from '@common'
import { UrlPath } from '@shared/helpers'

export interface OrganizationUrlProps {
  organization: Uuid
}

export interface SyncConfigUrlProps extends OrganizationUrlProps {
  id: Uuid
}

export const googleDriveAuthUrl: UrlPath<OrganizationUrlProps> = 'organization/:organization/google-drive/auth-url'
export const googleDriveConnectUrl: UrlPath<OrganizationUrlProps> = 'organization/:organization/google-drive/connect'
export const googleDriveConnectionUrl: UrlPath<OrganizationUrlProps> = 'organization/:organization/google-drive/connection'
export const googleDriveStatusUrl: UrlPath<OrganizationUrlProps> = 'organization/:organization/google-drive/status'
export const googleDriveFoldersUrl: UrlPath<OrganizationUrlProps> = 'organization/:organization/google-drive/folders'
export const googleDriveSyncConfigUrl: UrlPath<OrganizationUrlProps> = 'organization/:organization/google-drive/sync-config'
export const googleDriveSyncConfigIdUrl: UrlPath<SyncConfigUrlProps> = 'organization/:organization/google-drive/sync-config/:id'
export const googleDriveSyncUrl: UrlPath<OrganizationUrlProps> = 'organization/:organization/google-drive/sync'
export const googleDriveSyncHistoryUrl: UrlPath<OrganizationUrlProps> = 'organization/:organization/google-drive/sync-history'
export const googleDriveResolveUrl: UrlPath<OrganizationUrlProps> = 'organization/:organization/google-drive/resolve-url'
export const googleDriveLinkUrl: UrlPath<OrganizationUrlProps> = 'organization/:organization/google-drive/link'
export const googleDriveImportUrl: UrlPath<OrganizationUrlProps> = 'organization/:organization/google-drive/import'
